export const CircleTickSvg = () => {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75 37.5C75 58.2107 58.2107 75 37.5 75C16.7893 75 0 58.2107 0 37.5C0 16.7893 16.7893 0 37.5 0C58.2107 0 75 16.7893 75 37.5ZM9.37436 37.5C9.37436 53.0334 21.9666 65.6256 37.5 65.6256C53.0334 65.6256 65.6256 53.0334 65.6256 37.5C65.6256 21.9666 53.0334 9.37436 37.5 9.37436C21.9666 9.37436 9.37436 21.9666 9.37436 37.5Z"
        fill="#4A7130"
        id="circle"
      />
      <path
        d="M52.5061 21.4632C53.1189 22.0628 53.1683 23.0448 52.6158 23.7038C45.0235 32.7965 39.7073 39.3847 33.291 52.103C33.0092 52.6655 32.4348 53.0127 31.8146 52.9996C31.1926 52.9848 30.6346 52.6117 30.3766 52.0381C28.0111 46.8009 25.075 41.8485 21.6242 37.2725C20.7058 36.0936 20.8119 34.4006 21.8694 33.348C22.9286 32.2973 24.5989 32.2249 25.7423 33.1828C27.8371 34.9557 29.8367 36.8455 31.7264 38.8429C31.7264 38.8429 40.9888 27.3388 50.5131 21.2534C51.1461 20.8487 51.97 20.936 52.5061 21.4632Z"
        fill="#4A7130"
        id="tick"
      />
    </svg>
  );
};
